// components/FullPageLoader.jsx
import React from 'react';
import './FullPageLoader.css';

const FullPageLoader = () => {
  return (
    <div className="loader-overlay">
      <div className="loader-container">
        <div className="spinner" />
        <p>Extracting, please wait...</p>
      </div>
    </div>
  );
};

export default FullPageLoader;
